__turbopack_context__.v({
  "amount": "Banner-module__hdtNOG__amount",
  "bnbtn": "Banner-module__hdtNOG__bnbtn",
  "bnbtnprimary": "Banner-module__hdtNOG__bnbtnprimary",
  "bnbullet": "Banner-module__hdtNOG__bnbullet",
  "bnbullets": "Banner-module__hdtNOG__bnbullets",
  "bnby": "Banner-module__hdtNOG__bnby",
  "bncard": "Banner-module__hdtNOG__bncard",
  "bncardmain": "Banner-module__hdtNOG__bncardmain",
  "bnchip": "Banner-module__hdtNOG__bnchip",
  "bnctaRow": "Banner-module__hdtNOG__bnctaRow",
  "bnhero": "Banner-module__hdtNOG__bnhero",
  "bnherotext": "Banner-module__hdtNOG__bnherotext",
  "bnlink": "Banner-module__hdtNOG__bnlink",
  "bnmetric": "Banner-module__hdtNOG__bnmetric",
  "bnmetricnogap": "Banner-module__hdtNOG__bnmetricnogap",
  "bnmetrics": "Banner-module__hdtNOG__bnmetrics",
  "bnnote": "Banner-module__hdtNOG__bnnote",
  "bnoffer": "Banner-module__hdtNOG__bnoffer",
  "bnofferleft": "Banner-module__hdtNOG__bnofferleft",
  "bnofferright": "Banner-module__hdtNOG__bnofferright",
  "bnoffertop": "Banner-module__hdtNOG__bnoffertop",
  "bnplay": "Banner-module__hdtNOG__bnplay",
  "bnprice": "Banner-module__hdtNOG__bnprice",
  "bnpriceRow": "Banner-module__hdtNOG__bnpriceRow",
  "bnpricenow": "Banner-module__hdtNOG__bnpricenow",
  "bnpriceold": "Banner-module__hdtNOG__bnpriceold",
  "bnright": "Banner-module__hdtNOG__bnright",
  "bnsep": "Banner-module__hdtNOG__bnsep",
  "bnstar": "Banner-module__hdtNOG__bnstar",
  "bnstat": "Banner-module__hdtNOG__bnstat",
  "bnstatlabel": "Banner-module__hdtNOG__bnstatlabel",
  "bnstats": "Banner-module__hdtNOG__bnstats",
  "bnstatval": "Banner-module__hdtNOG__bnstatval",
  "bnstatvalBlue": "Banner-module__hdtNOG__bnstatvalBlue",
  "bnstatvalGreen": "Banner-module__hdtNOG__bnstatvalGreen",
  "bnstatvalPurple": "Banner-module__hdtNOG__bnstatvalPurple",
  "bnsub": "Banner-module__hdtNOG__bnsub",
  "bntag": "Banner-module__hdtNOG__bntag",
  "bntitle": "Banner-module__hdtNOG__bntitle",
  "bnvideowrapper": "Banner-module__hdtNOG__bnvideowrapper",
  "bnwrap": "Banner-module__hdtNOG__bnwrap",
  "ccdownload": "Banner-module__hdtNOG__ccdownload",
  "fee": "Banner-module__hdtNOG__fee",
  "feeGroup": "Banner-module__hdtNOG__feeGroup",
  "groupdis": "Banner-module__hdtNOG__groupdis",
  "medal": "Banner-module__hdtNOG__medal",
  "start": "Banner-module__hdtNOG__start",
  "titleGroup": "Banner-module__hdtNOG__titleGroup",
});
